import endpoints from '@/constants/endpoints';
import axiosV2 from '@/data/api/axiosv2';

export async function uploadProducts(file: File): Promise<void> {
  const endpoint = endpoints.productsCatalog.uploadBulkProducts;
  return await axiosV2.postForm(endpoint, {
    file: file,
  });
}

export async function updateProducts(file: File): Promise<void> {
  const endpoint = endpoints.productsCatalog.updateBulkProducts;
  return await axiosV2.patchForm(endpoint, {
    file: file,
  });
}
